export default __webpack_public_path__ + "static/media/hoseg3.730c4b5a.jpg";